// External help documentation links shown in the sidebar Help menu.
// Add new entries here as more docs are published.
import { Handshake } from 'lucide-react';

export const HELP_LINKS = [
  {
    label: 'Migrating from Pipedrive to AOS',
    description: 'Step-by-step guide for moving deals over.',
    url: 'https://scribehow.com/viewer/Migrating_Deals_from_Pipedrive_to_AOS__qZw121RIRmyjDKOcjMR4gQ?referrer=workspace',
    icon: Handshake,
  },
];
